import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-component',
  templateUrl: './help-component.component.html',
  styleUrls: ['./help-component.component.css']
})
export class HelpComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
